// @ts-check
//
// Taylor's Boats — VDP description "Read more". Clamps a long boat description
// to a few lines behind a toggle so it never dominates the page, then reveals
// the rest on demand.
//
// Progressive enhancement: without JS the full description renders. This script
// applies the clamp (`.is-clamped`) and only surfaces the toggle when the body
// actually overflows the collapsed height — short descriptions stay as-is.

(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  class VdpDescriptionBody extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('[data-vd-body]');
      this.toggleBtn = this.querySelector('[data-vd-toggle]');
      if (!this.body || !this.toggleBtn) return;

      this.expanded = false;
      this.moreLabel = this.dataset.moreLabel || 'Read more';
      this.lessLabel = this.dataset.lessLabel || 'Read less';

      this.evaluate();
      this.toggleBtn.addEventListener('click', this.onToggle);
      window.addEventListener('resize', this.evaluate, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.evaluate);
    }

    // Clamp the body and show the toggle only when the content is taller than
    // the collapsed cap. Re-runs on resize (line count shifts with width), but
    // never re-clamps while expanded.
    evaluate = () => {
      if (this.expanded) return;
      this.classList.add('is-clamped');
      const overflows = this.body.scrollHeight - this.body.clientHeight > 2;
      this.classList.toggle('is-clamped', overflows);
      this.toggleBtn.hidden = !overflows;
    };

    onToggle = () => {
      const startHeight = this.body.offsetHeight;

      this.expanded = !this.expanded;
      this.dataset.expanded = this.expanded ? 'true' : 'false';
      this.toggleBtn.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
      this.toggleBtn.textContent = this.expanded ? this.lessLabel : this.moreLabel;

      // The CSS state (cap + fade mask) is already applied by the attribute
      // flip above, so offsetHeight now reports the target height.
      const endHeight = this.body.offsetHeight;

      if (REDUCED_MOTION.matches) return;

      this.body.style.overflow = 'hidden';
      const animation = this.body.animate(
        { height: [`${startHeight}px`, `${endHeight}px`] },
        { duration: 300, easing: 'ease-in-out' },
      );
      animation.onfinish = () => {
        this.body.style.overflow = '';
      };
    };
  }

  if (!customElements.get('vdp-description-body')) {
    customElements.define('vdp-description-body', VdpDescriptionBody);
  }
})();
